export default {"src":"/_next/static/image/public/images/ic_icons.46d764fa505882d36477fa00a02a2753.svg","height":19,"width":108};